var render = function render(){
  var _vm$order$seller$user;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "elevation-1 rounded pa-5 white"
  }, [_c('v-row', {
    staticClass: "align-center"
  }, [_c('v-col', {
    attrs: {
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "d-flex align-center mb-3"
  }, [_c('h1', {
    staticClass: "secondary--text"
  }, [_vm._v(" " + _vm._s(_vm.order.id) + " ")]), _c('OrderIconsField', {
    attrs: {
      "order": _vm.order,
      "showPrintableInfo": true,
      "showDistributedInfo": true,
      "showGroupOrderInfo": true,
      "showClaimInfo": false,
      "showArchiveOrder": true
    }
  }), _vm.order.inquiries && _vm.order.inquiries.length ? _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "small": "",
      "color": "accent"
    },
    on: {
      "click": function ($event) {
        return _vm.navInquiries(_vm.order.inquiries);
      }
    }
  }, [_vm._v(" HAS CLAIM TICKET ")]) : _vm._e()], 1), _c('div', {
    staticClass: "caption secondary--text"
  }, [_vm._v(" Created at "), _c('code', {
    staticClass: "text-caption"
  }, [_vm._v(_vm._s(_vm._f("getOnlyDate")(_vm.order.created)) + " " + _vm._s(_vm._f("getOnlyTime")(_vm.order.created)) + " (GMT+" + _vm._s(_vm.getGmtDiff) + ")")]), _vm._v(" by "), _c('code', {
    staticClass: "text-caption"
  }, [_vm._v(" " + _vm._s((_vm$order$seller$user = _vm.order.seller.user.fullName) !== null && _vm$order$seller$user !== void 0 ? _vm$order$seller$user : _vm.order.seller.user.name) + " ")])]), _c('OrderExpirationExtender', {
    attrs: {
      "order": _vm.order
    },
    on: {
      "order-updated": function ($event) {
        return _vm.$emit('order-updated', $event);
      }
    }
  })], 1), _c('v-spacer'), _vm.paymentMethodData ? [_c('v-col', {
    staticClass: "ma-0 d-flex flex-column align-center justify-end",
    attrs: {
      "cols": "auto"
    }
  }, [_c('img', _vm._g(_vm._b({
    staticClass: "mr-2 ml-2",
    staticStyle: {
      "border-radius": "4px"
    },
    attrs: {
      "src": _vm.paymentMethodData.icon,
      "alt": _vm.paymentMethodData.description,
      "width": "24"
    }
  }, 'img', _vm.attrs, false), _vm.on)), _c('div', {
    staticClass: "text-caption mt-1"
  }, [_vm._v("Debited via " + _vm._s(_vm.paymentMethodData.description))])]), _c('v-divider', {
    staticClass: "ml-3 mr-3 mb-5 mt-5",
    attrs: {
      "inset": "",
      "vertical": ""
    }
  })] : _vm._e(), _vm._t("default"), _vm._t("dialog"), _c('v-col', {
    attrs: {
      "md": "auto"
    }
  }, [_c('h3', {
    staticClass: "warning--text text--lighten-1"
  }, [_vm._v(" " + _vm._s(_vm.order.cancelInformation.amount.plainText) + " ")]), _c('div', {
    staticClass: "text-caption"
  }, [_vm._v("Refunded order amount")])]), _c('v-col', {
    attrs: {
      "md": "auto"
    }
  }, [_c('h3', [_vm._v(" " + _vm._s(_vm.order.calculatedPrice.total.plainText) + " ")]), _c('div', {
    staticClass: "text-caption"
  }, [_vm._v("Total order amount")])]), _c('v-col', {
    attrs: {
      "md": "auto"
    }
  }, [_c('h3', {
    class: [_vm.order.calculatedPrice.balance.amount < 0 ? 'red--text' : 'green--text']
  }, [_vm._v(" " + _vm._s(_vm.order.calculatedPrice.balance.plainText) + " ")]), _c('div', {
    staticClass: "text-caption"
  }, [_vm._v("Order payment balance")])])], 2)], 1), _c('ExternalBookingSummary', {
    attrs: {
      "bookings": _vm.order.bookings,
      "tenant-name": _vm.order.seller.tenant.name
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }